module.exports = {
  localeName: 'he-IL',
  momentFormat: 'DD/MM/YYYY',
};
